// convert from jquery to vanila javascript 
var swatches = {
  'changeOption' : function (element) {
    var product_option = element.closest('.ul-swatches-colors').dataset.productOption;
    var product_option_value = element.dataset.productOptionValueId;
    var product_option_name = element.title;
    var product_option_type = element.closest('.ul-swatches-colors').dataset.type;

    var use_zoom = document.getElementById('check-use-zoom').value;

    if(element.closest('.swatches-options').classList.contains('checked')) {
      element.closest('.swatches-options').classList.remove('checked');
      element.closest('.ul-swatches-colors').querySelector('.swatches-info').innerHTML = '';

      if(product_option_type == 'select') {
        //$('#input-option' + product_option).val(0).trigger('change');
        document.getElementById('input-option' + product_option).value = 0;
        document.getElementById('input-option' + product_option).dispatchEvent(new Event('change'));
      }

      if(product_option_type == 'radio') {
        //$('#input-option' + product_option).find('.radio-option-value').removeAttr('checked');
        document.getElementById('input-option' + product_option).querySelector('.radio-option-value').removeAttribute('checked');
      }

      if(use_zoom == '1') {
        //$('#light-box-position').val('1');
        document.getElementById('light-box-position').value = '1';
        //$('#product-image-default').find('img').trigger('click');
        document.getElementById('product-image-default').querySelector('img').dispatchEvent(new Event('click'));
      } else {
        var thumb = document.getElementById('product-image-default').dataset.thumb;
        var popup = document.getElementById('product-image-default').dataset.popup;
        //$('#swatches-image-container .swatches-image').attr('href', popup).find('img').attr('src', thumb);
        document.getElementById('swatches-image-container').querySelector('.swatches-image').setAttribute('href', popup);
        document.getElementById('swatches-image-container').querySelector('.swatches-image').querySelector('img').setAttribute('src', thumb);
      }
    } else {
      element.closest('.ul-swatches-colors').querySelectorAll('.swatches-options').forEach(function (el) {
        el.classList.remove('checked');
      });
      element.closest('.swatches-options').classList.add('checked');
      element.closest('.ul-swatches-colors').querySelector('.swatches-info').innerHTML = product_option_name;

      if(product_option_type == 'select') {
        //$('#input-option' + product_option).val(product_option_value).trigger('change');
        document.getElementById('input-option' + product_option).value = product_option_value;
        document.getElementById('input-option' + product_option).dispatchEvent(new Event('change'));  
      }

      if(product_option_type == 'radio') {
        //$('#input-option' + product_option).find('#radio-option-value-' + product_option_value).trigger('click');
        document.getElementById('input-option' + product_option).querySelector('#radio-option-value-' + product_option_value).dispatchEvent(new Event('click'));
      }

      if(use_zoom == '1') {
        var pos = document.getElementById('product-image-options-' + product_option_value).dataset.pos;
        if(pos) {
          //$('#light-box-position').val(pos);
          document.getElementById('light-box-position').value = pos;
          //$('#product-image-options-' + product_option_value).find('img').trigger('click');
          document.getElementById('product-image-options-' + product_option_value).querySelector('img').dispatchEvent(new Event('click'));
        } else {
          //$('#light-box-position').val('1');
          document.getElementById('light-box-position').value = '1';
          //$('#product-image-default').find('img').trigger('click');
          document.getElementById('product-image-default').querySelector('img').dispatchEvent(new Event('click'));
        }
      } else {
        var thumb = document.getElementById('product-image-options-' + product_option_value).dataset.thumb;
        var popup = document.getElementById('product-image-options-' + product_option_value).dataset.popup;
        //$('#swatches-image-container .swatches-image').attr('href', popup).find('img').attr('src', thumb);
        document.getElementById('swatches-image-container').querySelector('.swatches-image').setAttribute('href', popup);
        document.getElementById('swatches-image-container').querySelector('.swatches-image').querySelector('img').setAttribute('src', thumb);
      }
    }
  },

  'changeSwatchInCategory' : function (element) {
    var product_option_value_id = element.dataset.productOptionValueId;
    var product_id = element.dataset.productId;

    if(element.closest('.swatches-options').classList.contains('checked')) {
      element.closest('.swatches-options').classList.remove('checked');

      var img_src = document.querySelector('.img-default-' + product_id).value;
      document.querySelector('.img-cate-' + product_id).setAttribute('src', img_src);
      if(mt.lazyloading_enable) {document.querySelector('.img-cate-' + product_id).setAttribute('srcset', img_src);}
    } else {
      element.closest('.ul-swatches-colors').querySelectorAll('.swatches-options').forEach(function (el) {
        el.classList.remove('checked');
      });
      element.closest('.swatches-options').classList.add('checked');

      if(document.querySelector('.img-swatch-' + product_id + '-' + product_option_value_id)) {
        var img_src = document.querySelector('.img-swatch-' + product_id + '-' + product_option_value_id).value;
        document.querySelector('.img-cate-' + product_id).setAttribute('src', img_src);
        if(mt.lazyloading_enable) {document.querySelector('.img-cate-' + product_id).setAttribute('srcset', img_src);}
      } else {
        var img_src = document.querySelector('.img-default-' + product_id).value;
        document.querySelector('.img-cate-' + product_id).setAttribute('src', img_src);
        if(mt.lazyloading_enable) {document.querySelector('.img-cate-' + product_id).setAttribute('srcset', img_src);}
      }
    }
  },
}